<template>
  <section
    class="live"
    v-if="Object.entries(translations.text).length"
  >
    <div
      class="progressNum"
      v-if="step > 0"
    >
      <ul>
        <li :class="{ active: step == 1 }"></li>
        <span class="step_divider"></span>
        <li :class="{ active: step == 2 }"></li>
        <span class="step_divider"></span>
        <li :class="{ active: step == 3 }"></li>
      </ul>
    </div>

    <div
      class="step"
      v-if="step == 0"
    >
      <h2 class="center">{{$t('individual_company')}}</h2>
      <a
        class="button btn-step0"
        @click="$bus.$emit('SelectLegalType', 'individual')"
      >{{ $t('individual').tUpper() }}</a>
      <a
        class="button btn-step0"
        @click="$bus.$emit('SelectLegalType', 'company')"
      >{{ $t('company').tUpper() }}</a>
    </div>

    <!--
 d888                    8888888 888b    888 8888888b. 8888888 888     888 8888888 8888888b.  888     888       d8888 888
d8888                      888   8888b   888 888  "Y88b  888   888     888   888   888  "Y88b 888     888      d88888 888
  888                      888   88888b  888 888    888  888   888     888   888   888    888 888     888     d88P888 888
  888                      888   888Y88b 888 888    888  888   Y88b   d88P   888   888    888 888     888    d88P 888 888
  888                      888   888 Y88b888 888    888  888    Y88b d88P    888   888    888 888     888   d88P  888 888
  888        888888        888   888  Y88888 888    888  888     Y88o88P     888   888    888 888     888  d88P   888 888
  888                      888   888   Y8888 888  .d88P  888      Y888P      888   888  .d88P Y88b. .d88P d8888888888 888
8888888                  8888888 888    Y888 8888888P" 8888888     Y8P     8888888 8888888P"   "Y88888P" d88P     888 88888888
    -->

    <div
      class="step"
      v-if="step == 1 && legalType == 'individual'"
    >
      <h2>{{ $t('personal_information') }}</h2>
      <div class="columns">
        <div class="column is-2">
          <label
            class="label"
            for="title"
          >{{ translations.text.title }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('title') }"
                :data-vv-as="translations.text.title"
                name="title"
                v-model="body.title"
              >
                <option value></option>
                <option
                  v-for="(item, index) in titles"
                  :value="index"
                  :key="index"
                >{{ item }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('title')"
              class="help is-danger"
            >{{ errors.first('title') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="firstname"
          >{{ translations.text.firstname }}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{ input: true, 'is-danger': errors.has('firstname') }"
              name="firstname"
              type="text"
              :data-vv-as="translations.text.firstname"
              :placeholder="translations.text.firstname"
              v-model="body.firstname"
            />
            <span
              v-show="errors.has('firstname')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('firstname') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="lastname"
          >{{ translations.text.lastname }}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{ input: true, 'is-danger': errors.has('lastname') }"
              name="lastname"
              type="text"
              :data-vv-as="translations.text.lastname"
              :placeholder="translations.text.lastname"
              v-model="body.lastname"
            />
            <span
              v-show="errors.has('lastname')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('lastname') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="email"
          >{{ translations.text.email }}</label>
          <p class="control">
            <input
              v-validate="'required|email|email-available'"
              :class="{ input: true, 'is-danger': errors.has('email') }"
              name="email"
              type="text"
              :data-vv-as="translations.text.email"
              :placeholder="translations.text.email"
              v-model="body.email"
            />
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="country"
          >{{translations.text.country}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('country') }"
                :data-vv-as="translations.text.country"
                name="country"
                v-model="body.country"
              >
                <option value=""></option>
                <option
                  v-for="(item, index) in filteredCountries"
                  :value="index"
                  :key="index"
                >{{item.name}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('country')"
              class="help is-danger"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
        <div class="columns column">
          <div class="column">
            <label
              class="label"
              for="phone"
            >{{ translations.text.phone }}</label>
            <div class="control relative">
              <div class="dialcodeBox">{{body.country!=''?body.dialCode:''}}</div>
              <input
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('phone'),'push-left':body.country!='' }"
                name="phone"
                type="text"
                :data-vv-as="translations.text.phone"
                :placeholder="translations.text.phone"
                v-model="body.phone"
              />
              <span
                v-show="errors.has('phone')"
                class="help is-danger"
              >{{ errors.first('phone') }}</span>
            </div>
          </div>
        </div>
      </div>
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>{{$t("next").tUpper()}}</span>
      </a>

    </div>

    <!--
 d888                     .d8888b.   .d88888b.  888b     d888 8888888b.     d8888 888b    888 Y88b   d88P
d8888                    d88P  Y88b d88P" "Y88b 8888b   d8888 888   Y88b   d88888 8888b   888  Y88b d88P
  888                    888    888 888     888 88888b.d88888 888    888  d88P888 88888b  888   Y88o88P
  888                    888        888     888 888Y88888P888 888   d88P d88P 888 888Y88b 888    Y888P
  888                    888        888     888 888 Y888P 888 8888888P" d88P  888 888 Y88b888     888
  888        888888      888    888 888     888 888  Y8P  888 888      d88P   888 888  Y88888     888
  888                    Y88b  d88P Y88b. .d88P 888   "   888 888     d8888888888 888   Y8888     888
8888888                   "Y8888P"   "Y88888P"  888       888 888    d88P     888 888    Y888     888
    -->

    <div
      class="step"
      v-if="step == 1 && legalType == 'company'"
    >
      <h2>{{ $t('company_information').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="company_name"
          >{{ translations.text.company_name.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('company_name') }"
              name="company_name"
              type="text"
              :data-vv-as="translations.text.company_name"
              :placeholder="translations.text.company_name"
              v-model="body.company_name"
            />
            <span
              v-show="errors.has('company_name')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('company_name') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="website"
          >{{ translations.text.company_website.tUpper() }}</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('website') }"
              name="website"
              type="text"
              :data-vv-as="translations.text.company_website"
              :placeholder="translations.text.website"
              v-model="body.website"
            />
            <span
              v-show="errors.has('website')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('website') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="skype_id"
          >{{ translations.text.skype_id.tUpper() }}</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('skype_id') }"
              name="skype_id"
              type="text"
              :data-vv-as="translations.text.skype_id"
              :placeholder="translations.text.skype_id"
              v-model="body.skype_id"
            />
            <span
              v-show="errors.has('skype_id')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('skype_id') }}</span>
          </p>
        </div>
      </div>
      <div
        v-if="!upgrade"
        class="columns"
      >
        <div class="column">
          <label
            class="label"
            for="country"
          >{{ translations.text.country.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('country') }"
                :data-vv-as="translations.text.country"
                name="country"
                v-model="body.country"
              >
                <option value></option>
                <option
                  v-for="(item, index) in filteredCountries"
                  :value="index"
                  :key="index"
                >{{ item.name }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('country')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
        <div class="columns column">
          <div class="column is-one-quarters">
            <label
              class="label"
              for="dialCode"
            >{{ $t('dial_code').tUpper() }}</label>
            <p class="control">
              <img
                class="flag"
                :class="'flag-' + body.country.toLowerCase()"
              />
              <input
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dialCode') }"
                name="dialCode"
                class="dialCode"
                type="text"
                :data-vv-as="$t('dial_code')"
                :placeholder="$t('dial_code')"
                v-model="body.dialCode"
              />
              <span
                v-show="errors.has('dialCode')"
                class="help is-danger"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{ errors.first('dialCode') }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="phone"
            >{{ translations.text.phone.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('phone') }"
                name="phone"
                type="text"
                :data-vv-as="translations.text.phone"
                :placeholder="translations.text.phone"
                v-model="body.phone"
              />
              <span
                v-show="errors.has('phone')"
                class="help is-danger"
              >{{ errors.first('phone') }}</span>
            </p>
          </div>
        </div>
      </div>

      <h2>{{ $t('company_registration_information').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="dob"
          >{{ translations.text.date_of_registration.tUpper() }}</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            for="dob_day"
          >{{ translations.text.day.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dob_day') }"
                :data-vv-as="translations.text.day"
                name="dob_day"
                v-model="body.dob.day"
              >
                <option value></option>
                <option
                  v-for="day in monthDayIndexes"
                  :value="day"
                  :key="day"
                >{{ day }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_day')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_day') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_month"
          >{{ translations.text.month.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dob_month') }"
                :data-vv-as="translations.text.month"
                name="dob_month"
                v-model="body.dob.month"
              >
                <option value></option>
                <option
                  v-for="(month, index) in translations.months"
                  :value="index"
                  :key="index"
                >{{ month }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_month')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_month') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_year"
          >{{ translations.text.year.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dob_year') }"
                :data-vv-as="translations.text.year"
                name="dob_year"
                v-model="body.dob.year"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{ year }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_year')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_year') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address"
          >{{ translations.text.address.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('address') }"
              name="address"
              type="text"
              :data-vv-as="translations.text.address"
              :placeholder="translations.text.address"
              v-model="body.address"
            />
            <span
              v-show="errors.has('address')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('address') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address2"
          >{{ translations.text.address2.tUpper() }}</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('address2') }"
              name="address2"
              type="text"
              :data-vv-as="translations.text.address2"
              :placeholder="translations.text.address2"
              v-model="body.address2"
            />
            <span
              v-show="errors.has('address2')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('address2') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="post_code"
          >{{ translations.text.post_code.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('post_code') }"
              name="post_code"
              type="text"
              :data-vv-as="translations.text.post_code"
              :placeholder="translations.text.post_code"
              v-model="body.post_code"
            />
            <span
              v-show="errors.has('post_code')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('post_code') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="city"
          >{{ translations.text.city.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('city') }"
              name="city"
              type="text"
              :data-vv-as="translations.text.city"
              :placeholder="translations.text.city"
              v-model="body.city"
            />
            <span
              v-show="errors.has('city')"
              class="help is-danger"
            >{{ errors.first('city') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="state_province"
          >{{ translations.text.state_province.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('state_province') }"
              name="state_province"
              type="text"
              :data-vv-as="translations.text.state_province"
              :placeholder="translations.text.state_province"
              v-model="body.state_province"
            />
            <span
              v-show="errors.has('state_province')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('state_province') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="year_moved_to_address"
          >{{ translations.text.year_moved_to_address.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('year_moved_to_address') }"
                :data-vv-as="translations.text.year_moved_to_address"
                name="year_moved_to_address"
                v-model="body.year_moved_to_address"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{ year }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('year_moved_to_address')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('year_moved_to_address') }}</span>
          </p>
        </div>
      </div>

      <template v-if="!upgrade">
        <h2>{{ $t('login_information').tUpper() }}</h2>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="email"
            >{{ translations.text.email.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|email|email-available'"
                :class="{ input: true, 'is-danger': errors.has('email') }"
                name="email"
                type="text"
                :data-vv-as="translations.text.email"
                :placeholder="translations.text.email"
                v-model="body.email"
              />
              <span
                v-show="errors.has('email')"
                class="help is-danger"
              >{{ errors.first('email') }}</span>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="password"
            >{{ translations.text.password.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|strong-password|confirmed:confirm_password'"
                :class="{ input: true, 'is-danger': errors.has('password') }"
                name="password"
                type="password"
                :data-vv-as="translations.text.password"
                :placeholder="translations.text.password"
                v-model="body.password"
              />
              <span
                v-show="errors.has('password')"
                class="help is-danger"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{ errors.first('password') }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="confirm_password"
            >{{ translations.text.confirm_password.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('confirm_password') }"
                name="confirm_password"
                ref="confirm_password"
                type="password"
                :data-vv-as="translations.text.confirm_password"
                :placeholder="translations.text.confirm_password"
                v-model="body.confirm_password"
              />
              <span
                v-show="errors.has('confirm_password')"
                class="help is-danger"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{ errors.first('confirm_password') }}</span>
            </p>
          </div>
        </div>

      </template>

      <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>{{$t("next").tUpper()}}</span>
      </a>
    </div>

    <!--
 .d8888b.                   8888888 888b    888 8888888b. 8888888 888     888 8888888 8888888b.  888     888       d8888 888
d88P  Y88b                    888   8888b   888 888  "Y88b  888   888     888   888   888  "Y88b 888     888      d88888 888
       888                    888   88888b  888 888    888  888   888     888   888   888    888 888     888     d88P888 888
     .d88P                    888   888Y88b 888 888    888  888   Y88b   d88P   888   888    888 888     888    d88P 888 888
 .od888P"                     888   888 Y88b888 888    888  888    Y88b d88P    888   888    888 888     888   d88P  888 888
d88P"           888888        888   888  Y88888 888    888  888     Y88o88P     888   888    888 888     888  d88P   888 888
888"                          888   888   Y8888 888  .d88P  888      Y888P      888   888  .d88P Y88b. .d88P d8888888888 888
888888888                   8888888 888    Y888 8888888P" 8888888     Y8P     8888888 8888888P"   "Y88888P" d88P     888 88888888
    -->

    <div
      class="step"
      v-if="step == 2 && legalType == 'individual'"
    >
      <h2>{{ $t('personal_information').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="dob"
          >{{ translations.text.date_of_birth.tUpper() }}</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            for="dob_day"
          >{{ translations.text.day.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dob_day') }"
                :data-vv-as="translations.text.day"
                name="dob_day"
                v-model="body.dob.day"
              >
                <option value></option>
                <option
                  v-for="day in monthDayIndexes"
                  :value="day"
                  :key="day"
                >{{ day }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_day')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_day') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_month"
          >{{ translations.text.month.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('dob_month') }"
                :data-vv-as="translations.text.month"
                name="dob_month"
                v-model="body.dob.month"
              >
                <option value></option>
                <option
                  v-for="(month, index) in translations.months"
                  :value="index"
                  :key="index"
                >{{ month }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_month')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_month') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_year"
          >{{ translations.text.year.tUpper() }}</label>
          <p class="control">
            <input
              type="hidden"
              name=""
            />
            <span class="select is-fullwidth">
              <select
                v-validate="{ required: true, 'is-over-18': body.dob.day + '-' + body.dob.month + '-' + body.dob.year }"
                :class="{ input: true, 'is-danger': errors.has('dob_year') }"
                :data-vv-as="translations.text.year"
                name="dob_year"
                v-model="body.dob.year"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{ year }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_year')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_year') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="gender"
          >{{ translations.text.gender.tUpper() }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('gender') }"
                :data-vv-as="translations.text.gender"
                name="gender"
                v-model="body.gender"
              >
                <option value></option>
                <option
                  v-for="(item, index) in translations.genders"
                  :value="index"
                  :key="index"
                >{{ item }}</option>
              </select>
            </div>
            <span
              v-show="errors.has('gender')"
              class="help is-danger"
            >{{ errors.first('gender') }}</span>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address"
          >{{ translations.text.address.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('address') }"
              name="address"
              type="text"
              :data-vv-as="translations.text.address"
              :placeholder="translations.text.address"
              v-model="body.address"
            />
            <span
              v-show="errors.has('address')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('address') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address2"
          >{{ translations.text.address2.tUpper() }}</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('address2') }"
              name="address2"
              type="text"
              :data-vv-as="translations.text.address2"
              :placeholder="translations.text.address2"
              v-model="body.address2"
            />
            <span
              v-show="errors.has('address2')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('address2') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="post_code"
          >{{ translations.text.post_code.tUpper() }}</label>
          <div class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('post_code') }"
              name="post_code"
              type="text"
              :data-vv-as="translations.text.post_code"
              :placeholder="translations.text.post_code"
              v-model="body.post_code"
            />
            <span
              v-show="errors.has('post_code')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('post_code') }}</span>
          </div>
        </div>
        <div class="column">
          <label
            class="label"
            for="city"
          >{{ translations.text.city.tUpper() }}</label>
          <div class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('city') }"
              name="city"
              type="text"
              :data-vv-as="translations.text.city"
              :placeholder="translations.text.city"
              v-model="body.city"
            />
            <span
              v-show="errors.has('city')"
              class="help is-danger"
            >{{ errors.first('city') }}</span>
          </div>
        </div>
        <div class="column">
          <label
            class="label"
            for="state_province"
          >{{ translations.text.state_province.tUpper() }}</label>
          <div class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('state_province') }"
              name="state_province"
              type="text"
              :data-vv-as="translations.text.state_province"
              :placeholder="translations.text.state_province"
              v-model="body.state_province"
            />
            <span
              v-show="errors.has('state_province')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('state_province') }}</span>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="year_moved_to_address"
          >{{ translations.text.year_moved_to_address.tUpper() }}</label>
          <div class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('year_moved_to_address') }"
                :data-vv-as="translations.text.year_moved_to_address"
                name="year_moved_to_address"
                v-model="body.year_moved_to_address"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{ year }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('year_moved_to_address')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('year_moved_to_address') }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="website"
          >{{ translations.text.website.tUpper() }} ({{ translations.text.not_required }})</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('website') }"
              name="website"
              type="text"
              :data-vv-as="translations.text.website"
              :placeholder="translations.text.website"
              v-model="body.website"
            />
            <span
              v-show="errors.has('website')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('website') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="skype_id"
          >{{ translations.text.skype_id.tUpper() }} ({{ translations.text.not_required }})</label>
          <p class="control">
            <input
              :class="{ input: true, 'is-danger': errors.has('skype_id') }"
              name="skype_id"
              type="text"
              :data-vv-as="translations.text.skype_id"
              :placeholder="translations.text.skype_id"
              v-model="body.skype_id"
            />
            <span
              v-show="errors.has('skype_id')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('skype_id') }}</span>
          </p>
        </div>
      </div>

      <!-- <h2>{{$t('login_information').tUpper()}}</h2> -->
      <div
        class="columns"
        v-if="!upgrade"
      >
        <div class="column">
          <label
            class="label"
            for="password"
          >{{ translations.text.password.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required|strong-password|confirmed:confirm_password'"
              :class="{ input: true, 'is-danger': errors.has('password') }"
              name="password"
              type="password"
              :data-vv-as="translations.text.password"
              :placeholder="translations.text.password"
              v-model="body.password"
            />
            <span
              v-show="errors.has('password')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="confirm_password"
          >{{ translations.text.confirm_password.tUpper() }}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('confirm_password') }"
              name="confirm_password"
              ref="confirm_password"
              type="password"
              :data-vv-as="translations.text.confirm_password"
              :placeholder="translations.text.confirm_password"
              v-model="body.confirm_password"
            />
            <span
              v-show="errors.has('confirm_password')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('confirm_password') }}</span>
          </p>
        </div>
      </div>

      <a
        v-if="!upgrade"
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>{{$t("next").tUpper()}}</span>
      </a>
    </div>

    <!--
 .d8888b.                    .d8888b.   .d88888b.  888b     d888 8888888b.     d8888 888b    888 Y88b   d88P
d88P  Y88b                  d88P  Y88b d88P" "Y88b 8888b   d8888 888   Y88b   d88888 8888b   888  Y88b d88P
       888                  888    888 888     888 88888b.d88888 888    888  d88P888 88888b  888   Y88o88P
     .d88P                  888        888     888 888Y88888P888 888   d88P d88P 888 888Y88b 888    Y888P
 .od888P"                   888        888     888 888 Y888P 888 8888888P" d88P  888 888 Y88b888     888
d88P"           888888      888    888 888     888 888  Y8P  888 888      d88P   888 888  Y88888     888
888"                        Y88b  d88P Y88b. .d88P 888   "   888 888     d8888888888 888   Y8888     888
888888888                    "Y8888P"   "Y88888P"  888       888 888    d88P     888 888    Y888     888
    -->

    <div
      class="step"
      v-if="step == 2 && legalType == 'company'"
    >
      <h2>{{ $t('company_shareholders_directors').tUpper() }}</h2>

      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="numberOfShareholders"
          >{{ translations.text.number_of_shareholders.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('numberOfShareholders') }"
                :data-vv-as="translations.text.number_of_shareholders"
                name="numberOfShareholders"
                v-model="numberOfShareholders"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </span>
            <span
              v-show="errors.has('numberOfShareholders')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('numberOfShareholders') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="numberOfDirectors"
          >{{ translations.text.number_of_directors.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('numberOfDirectors') }"
                :data-vv-as="translations.text.number_of_directors"
                name="numberOfDirectors"
                v-model="numberOfDirectors"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </span>
            <span
              v-show="errors.has('numberOfDirectors')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('numberOfDirectors') }}</span>
          </p>
        </div>
      </div>
      <!--
		         888                               888               888      888
		         888                               888               888      888
		         888                               888               888      888
		.d8888b  88888b.   8888b.  888d888 .d88b.  88888b.   .d88b.  888  .d88888  .d88b.  888d888 .d8888b
		88K      888 "88b     "88b 888P"  d8P  Y8b 888 "88b d88""88b 888 d88" 888 d8P  Y8b 888P"   88K
		"Y8888b. 888  888 .d888888 888    88888888 888  888 888  888 888 888  888 88888888 888     "Y8888b.
		     X88 888  888 888  888 888    Y8b.     888  888 Y88..88P 888 Y88b 888 Y8b.     888          X88
		 88888P' 888  888 "Y888888 888     "Y8888  888  888  "Y88P"  888  "Y88888  "Y8888  888      88888P'
      -->
      <div
        v-for="(person, index) in body.shareholders"
        class="shareholders-directors"
        :key="index"
      >
        <h2 :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t('shareholder').tUpper()}} - {{index+1}}</h2>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="firstname"
            >{{ translations.text.firstname.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('sh-firstname_'+index) }"
                :name="'sh-firstname_'+index"
                type="text"
                :data-vv-as="translations.text.firstname"
                :placeholder="translations.text.firstname"
                v-model="person.firstname"
              />
              <span
                v-show="errors.has('sh-firstname_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-firstname_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="lastname"
            >{{ translations.text.lastname.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('sh-lastname_'+index) }"
                :name="'sh-lastname_'+index"
                type="text"
                :data-vv-as="translations.text.lastname"
                :placeholder="translations.text.lastname"
                v-model="person.lastname"
              />
              <span
                v-show="errors.has('sh-lastname_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-lastname_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="dob"
            >{{ translations.text.date_of_birth.tUpper() }}</label>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label is-small"
              for="dob_day"
            >{{ translations.text.day.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-dob_day_'+index) }"
                  :data-vv-as="translations.text.day"
                  :name="'sh-dob_day_' + index"
                  v-model="person.dob.day"
                >
                  <option value></option>
                  <option
                    v-for="day in monthDayIndexes"
                    :value="day"
                    :key="day"
                  >{{ day }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_day_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_day_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_month"
            >{{ translations.text.month.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-dob_month_'+index) }"
                  :data-vv-as="translations.text.month"
                  :name="'sh-dob_month_' + index"
                  v-model="person.dob.month"
                >
                  <option value></option>
                  <option
                    v-for="(month, index) in translations.months"
                    :value="index"
                    :key="index"
                  >{{ month }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_month_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_month_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_year"
            >{{ translations.text.year.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
                  :class="{ input: true, 'is-danger': errors.has('sh-dob_year_' + index) }"
                  :data-vv-as="translations.text.year"
                  :name="'sh-dob_year_' + index"
                  v-model="person.dob.year"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{ year }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_year_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_year_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address"
            >{{ translations.text.address.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-address_'+index) }"
                :name="'sh-address_'+index"
                type="text"
                :data-vv-as="translations.text.address"
                :placeholder="translations.text.address"
                v-model="person.address"
              />
              <span
                v-show="errors.has('sh-address_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-address_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address2"
            >{{ translations.text.address2.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="''"
                :class="{'input': true, 'is-danger': errors.has('sh-address2_'+index) }"
                :name="'sh-address2_'+index"
                type="text"
                :data-vv-as="translations.text.address2"
                :placeholder="translations.text.address2"
                v-model="person.address2"
              />
              <span
                v-show="errors.has('sh-address2_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-address2_' + index) }}</span>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="post_code"
            >{{ translations.text.post_code.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-post_code_'+index) }"
                :name="'sh-post_code_'+index"
                type="text"
                :data-vv-as="translations.text.post_code"
                :placeholder="translations.text.post_code"
                v-model="person.post_code"
              />
              <span
                v-show="errors.has('sh-post_code_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-post_code_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="city"
            >{{ translations.text.city.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-city_'+index) }"
                :name="'sh-city_'+index"
                type="text"
                :data-vv-as="translations.text.city"
                :placeholder="translations.text.city"
                v-model="person.city"
              />
              <span
                v-show="errors.has('sh-city_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-city_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="state_province"
            >{{ translations.text.state_province.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-state_province_'+index) }"
                :name="'sh-state_province_'+index"
                type="text"
                :data-vv-as="translations.text.state_province"
                :placeholder="translations.text.state_province"
                v-model="person.state_province"
              />
              <span
                v-show="errors.has('sh-state_province_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-state_province_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="country"
            >{{ translations.text.country.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-country_'+index) }"
                  :data-vv-as="translations.text.country"
                  :name="'sh-country_' + index"
                  v-model="person.country"
                >
                  <option value></option>
                  <option
                    v-for="(item, index) in filteredCountries"
                    :value="index"
                    :key="index"
                  >{{ item.name }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-country_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-country_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="year_moved_to_address"
            >{{ translations.text.year_moved_to_address.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-year_moved_to_address_'+index) }"
                  :data-vv-as="translations.text.year_moved_to_address"
                  :name="'sh-year_moved_to_address_' + index"
                  v-model="person.year_moved_to_address"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{ year }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-year_moved_to_address_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-year_moved_to_address_' + index) }}</span>
            </p>
          </div>
        </div>
      </div>
      <!--
		     888 d8b                          888
		     888 Y8P                          888
		     888                              888
		 .d88888 888 888d888 .d88b.   .d8888b 888888 .d88b.  888d888 .d8888b
		d88" 888 888 888P"  d8P  Y8b d88P"    888   d88""88b 888P"   88K
		888  888 888 888    88888888 888      888   888  888 888     "Y8888b.
		Y88b 888 888 888    Y8b.     Y88b.    Y88b. Y88..88P 888          X88
		 "Y88888 888 888     "Y8888   "Y8888P  "Y888 "Y88P"  888      88888P'
      -->
      <div
        v-for="(person, index) in body.directors"
        class="shareholders-directors"
        :key="index"
      >
        <h2 :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t('director').tUpper()}} - {{index+1}}</h2>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="firstname"
            >{{ translations.text.firstname.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('dir-firstname_'+index) }"
                :name="'dir-firstname_'+index"
                type="text"
                :data-vv-as="translations.text.firstname"
                :placeholder="translations.text.firstname"
                v-model="person.firstname"
              />
              <span
                v-show="errors.has('dir-firstname_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-firstname_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="lastname"
            >{{ translations.text.lastname.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('dir-lastname_'+index) }"
                :name="'dir-lastname_'+index"
                type="text"
                :data-vv-as="translations.text.lastname"
                :placeholder="translations.text.lastname"
                v-model="person.lastname"
              />
              <span
                v-show="errors.has('dir-lastname_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-lastname_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="dob"
            >{{ translations.text.date_of_birth.tUpper() }}</label>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label is-small"
              for="dob_day"
            >{{ translations.text.day.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-dob_day_'+index) }"
                  :data-vv-as="translations.text.day"
                  :name="'dir-dob_day_' + index"
                  v-model="person.dob.day"
                >
                  <option value></option>
                  <option
                    v-for="day in monthDayIndexes"
                    :value="day"
                    :key="day"
                  >{{ day }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_day_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_day_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_month"
            >{{ translations.text.month.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-dob_month_'+index) }"
                  :data-vv-as="translations.text.month"
                  :name="'dir-dob_month_' + index"
                  v-model="person.dob.month"
                >
                  <option value></option>
                  <option
                    v-for="(month, index) in translations.months"
                    :value="index"
                    :key="index"
                  >{{ month }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_month_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_month_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_year"
            >{{ translations.text.year.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
                  :class="{ input: true, 'is-danger': errors.has('dir-dob_year_' + index) }"
                  :data-vv-as="translations.text.year"
                  :name="'dir-dob_year_' + index"
                  v-model="person.dob.year"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{ year }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_year_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_year_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address"
            >{{ translations.text.address.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-address_'+index) }"
                :name="'dir-address_'+index"
                type="text"
                :data-vv-as="translations.text.address"
                :placeholder="translations.text.address"
                v-model="person.address"
              />
              <span
                v-show="errors.has('dir-address_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-address_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address2"
            >{{ translations.text.address2.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="''"
                :class="{'input': true, 'is-danger': errors.has('dir-address2_'+index) }"
                :name="'dir-address2_'+index"
                type="text"
                :data-vv-as="translations.text.address2"
                :placeholder="translations.text.address2"
                v-model="person.address2"
              />
              <span
                v-show="errors.has('dir-address2_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-address2_' + index) }}</span>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="post_code"
            >{{ translations.text.post_code.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-post_code_'+index) }"
                :name="'dir-post_code_'+index"
                type="text"
                :data-vv-as="translations.text.post_code"
                :placeholder="translations.text.post_code"
                v-model="person.post_code"
              />
              <span
                v-show="errors.has('dir-post_code_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-post_code_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="city"
            >{{ translations.text.city.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-city_'+index) }"
                :name="'dir-city_'+index"
                type="text"
                :data-vv-as="translations.text.city"
                :placeholder="translations.text.city"
                v-model="person.city"
              />
              <span
                v-show="errors.has('dir-city_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-city_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="state_province"
            >{{ translations.text.state_province.tUpper() }}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-state_province_'+index) }"
                :name="'dir-state_province_'+index"
                type="text"
                :data-vv-as="translations.text.state_province"
                :placeholder="translations.text.state_province"
                v-model="person.state_province"
              />
              <span
                v-show="errors.has('dir-state_province_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-state_province_' + index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="country"
            >{{ translations.text.country.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-country_'+index) }"
                  :data-vv-as="translations.text.country"
                  :name="'dir-country_' + index"
                  v-model="person.country"
                >
                  <option value></option>
                  <option
                    v-for="(item, index) in filteredCountries"
                    :value="index"
                    :key="index"
                  >{{ item.name }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-country_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-country_' + index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="year_moved_to_address"
            >{{ translations.text.year_moved_to_address.tUpper() }}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-year_moved_to_address_'+index) }"
                  :data-vv-as="translations.text.year_moved_to_address"
                  :name="'dir-year_moved_to_address_' + index"
                  v-model="person.year_moved_to_address"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{ year }}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-year_moved_to_address_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-year_moved_to_address_' + index) }}</span>
            </p>
          </div>
        </div>
      </div>

      <a
        v-if="!upgrade"
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>{{$t("next").tUpper()}}</span>
      </a>
    </div>

    <!--
 .d8888b.                   888888b.    .d88888b. 88888888888 888    888
d88P  Y88b                  888  "88b  d88P" "Y88b    888     888    888
     .d88P                  888  .88P  888     888    888     888    888
    8888"                   8888888K.  888     888    888     8888888888
     "Y8b.                  888  "Y88b 888     888    888     888    888
888    888      888888      888    888 888     888    888     888    888
Y88b  d88P                  888   d88P Y88b. .d88P    888     888    888
 "Y8888P"                   8888888P"   "Y88888P"     888     888    888
    -->

    <div
      class="step"
      v-if="step == 3"
    >
      <h2>{{ $t('financial_information').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="total_estimated_net_worth"
          >{{ translations.text.total_estimated_net_worth.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('total_estimated_net_worth') }"
                :data-vv-as="translations.text.total_estimated_net_worth"
                name="total_estimated_net_worth"
                v-model="body.total_estimated_net_worth"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="<5000">{{ $t('less_than_amount', { amount: '€5.000' }).tTitle() }}</option>
                <option value="5000-49999">€5.000 - €49.999</option>
                <option value="50.000-99999">€50.000 - €99.999</option>
                <option value=">100000">{{ $t('over_amount', { amount: '€100.000' }).tTitle() }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('total_estimated_net_worth')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('total_estimated_net_worth') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="total_estimated_annual_income"
          >{{ translations.text.total_estimated_annual_income.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('total_estimated_annual_income') }"
                :data-vv-as="translations.text.total_estimated_annual_income"
                name="total_estimated_annual_income"
                v-model="body.total_estimated_annual_income"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="<15000">{{ $t('less_than_amount', { amount: '€15.000' }).tTitle() }}</option>
                <option value="15000-49999">€15.000 - €49.999</option>
                <option value="50.000-99999">€50.000 - €99.999</option>
                <option value=">100000">{{ $t('over_amount', { amount: '€100.000' }).tTitle() }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('total_estimated_annual_income')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('total_estimated_annual_income') }}</span>
          </p>
        </div>
      </div>

      <h2>{{ $t('employment_information').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="employment_status"
          >{{ translations.text.employment_status.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('employment_status') }"
                :data-vv-as="translations.text.employment_status"
                name="employment_status"
                v-model="body.employment_status"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="employed">{{ translations.text.employed }}</option>
                <option value="selfEmployed">{{ translations.text.self_employed }}</option>
                <option value="retired">{{ translations.text.retired }}</option>
                <option value="student">{{ translations.text.student }}</option>
                <option value="unemployed">{{ translations.text.unemployed }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('employment_status')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('employment_status') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="source_of_income"
          >{{ translations.text.source_of_income.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('source_of_income') }"
                :data-vv-as="translations.text.source_of_income"
                name="source_of_income"
                v-model="body.source_of_income"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="employment">{{ translations.text.employment }}</option>
                <option value="inheritance">{{ translations.text.inheritance }}</option>
                <option value="investment">{{ translations.text.investment }}</option>
                <option value="other">{{ translations.text.other }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('source_of_income')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('source_of_income') }}</span>
          </p>
        </div>
      </div>

      <h2>{{ $t('trading_experience').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="forex_cfds_and_other_instruments"
          >{{ translations.text.forex_cfds_and_other_instruments.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('forex_cfds_and_other_instruments') }"
                :data-vv-as="translations.text.forex_cfds_and_other_instruments"
                name="forex_cfds_and_other_instruments"
                v-model="body.forex_cfds_and_other_instruments"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="yes">{{ translations.text.yes }}</option>
                <option value="no">{{ translations.text.no }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('forex_cfds_and_other_instruments')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('forex_cfds_and_other_instruments') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="lose_capital_risk"
          >{{ translations.text.lose_capital_risk.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('lose_capital_risk') }"
                :data-vv-as="translations.text.lose_capital_risk"
                name="lose_capital_risk"
                v-model="body.lose_capital_risk"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="yes">{{ translations.text.yes }}</option>
                <option value="no">{{ translations.text.no }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('lose_capital_risk')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('lose_capital_risk') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="prev_pro_qualifications"
          >{{ translations.text.prev_pro_qualifications.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('prev_pro_qualifications') }"
                :data-vv-as="translations.text.prev_pro_qualifications"
                name="prev_pro_qualifications"
                v-model="body.prev_pro_qualifications"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="yes">{{ translations.text.yes }}</option>
                <option value="no">{{ translations.text.no }}</option>
              </select>
            </span>
            <span
              v-show="errors.has('prev_pro_qualifications')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('prev_pro_qualifications') }}</span>
          </p>
        </div>
      </div>

      <h2 v-if="!upgrade">{{ $t('choose_wallet_currency').tUpper() }}</h2>
      <div
        v-if="!upgrade"
        class="columns"
      >
        <div class="column">
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('walletCurrency') }"
                :data-vv-as="translations.text.walletCurrency"
                name="walletCurrency"
                v-model="body.walletCurrency"
              >
                <option
                  value
                  selected="selected"
                >{{ $t("select_currency").tTitle() }}</option>
                <option
                  v-for="(c, i) in $getCurrencies()"
                  :key="i"
                  :value="i"
                >{{i}} ({{c.symbol}})</option>
              </select>
            </span>
            <span
              v-show="errors.has('walletCurrency')"
              class="help is-danger"
            >{{ errors.first('walletCurrency') }}</span>
          </p>
        </div>
      </div>
      <h2>{{ $t('choose_trading_platform').tUpper() }}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="platform"
          >{{ translations.text.platform.tUpper() }}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('platform') }"
                :data-vv-as="translations.text.platform"
                name="platform"
                v-model="body.platform"
              >
                <option value>{{ translations.text.select_option }}</option>
                <option value="mt4">MT4</option>
                <option value="mt5">MT5</option>
              </select>
            </span>
            <span
              v-show="errors.has('platform')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('platform') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="tradingAccountCurrency"
          >{{translations.text.choose_currency.tUpper()}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('tradingAccountCurrency') }"
                :data-vv-as="translations.text.currency"
                name="currency"
                v-model="body.tradingAccountCurrency"
              >
                <option
                  value
                  selected="selected"
                >{{ $t("select_currency").tTitle() }}</option>
                <option
                  v-for="(c, i) in $getCurrencies()"
                  :key="i"
                  :value="i"
                >{{i}} ({{c.symbol}})</option>
              </select>
            </span>
            <span
              v-show="errors.has('tradingAccountCurrency')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('tradingAccountCurrency') }}</span>
          </p>
        </div>
        <div
          class="column"
          v-if="grantNoDepositBonus === false"
        >
          <label
            class="label"
            for="account_type"
          >{{translations.text.account_type.tUpper()}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required|is-islamic'"
                :class="{'input': true, 'is-danger': errors.has('account_type') }"
                :data-vv-as="translations.text.account_type"
                name="account_type"
                v-model="body.account_type"
              >
                <option value>{{translations.text.select_option}}</option>
                <option
                  v-for="(g, i) in groups"
                  :key="i"
                  :value="g.name"
                  :data-currency="g.currency"
                  :ref="'group-' + g.name"
                >{{g.display_name}}{{(body.tradingAccountCurrency == '' ? " (" + g.currency + ")" : "")}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('account_type')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('account_type') }}</span>
            <span
              v-if="body.account_type === 'pamm-investor'"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
              style="margin-top: 15px;"
            > {{ $t("pamm_investor_selection_note") }}</span>
          </p>
        </div>
      </div>
      <div
        v-if="BonusConfig.depositBonus.enabled && !grantNoDepositBonus && body.account_type !== 'pamm-investor' && body.account_type !== 'vip'"
        class="columns"
      >
        <div class="column">
          <p class="control">
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('include_account_in_bonus_program') }"
                name="include_account_in_bonus_program"
                type="checkbox"
                :data-vv-as="translations.text.include_account_in_bonus_program"
                v-model="body.include_account_in_bonus_program"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.include_account_in_bonus_program"></span>
            </label>
            <span
              v-show="errors.has('include_account_in_bonus_program')"
              class="help is-danger"
            >{{ errors.first('include_account_in_bonus_program') }}</span>
          </p>
        </div>
      </div>

      <div
        v-if="body.include_account_in_bonus_program && body.account_type !== 'vip'"
        class="columns"
      >
        <div class="column">
          <p
            class="control"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('bonus_tos_with_link') }"
                name="bonus_tos_with_link"
                type="checkbox"
                :data-vv-as="translations.text.bonus_tos_with_link"
                v-model="body.bonus_tos_with_link"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.bonus_tos_with_link"></span>
            </label>
            <span
              v-show="errors.has('bonus_tos_with_link')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('bonus_tos_with_link') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p
            class="control"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('tos_with_link') }"
                name="tos_with_link"
                type="checkbox"
                :data-vv-as="translations.text.tos_with_link"
                v-model="body.tos_with_link"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.tos_with_link"></span>
            </label>
            <span
              v-show="errors.has('tos_with_link')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('tos_with_link') }}</span>
          </p>
        </div>
      </div>
      <div v-if="!upgrade">
        <div class="columns">
          <div class="column">
            <p class="control">
              <label class="checkbox">
                <input
                  class="agreements"
                  :class="{ 'is-danger': errors.has('agree_terms_marketing') }"
                  name="agree_terms_marketing"
                  type="checkbox"
                  :data-vv-as="translations.text.agree_terms_marketing"
                  v-model="body.agree_terms_marketing"
                />
                <span class="checkmark"></span>
                <!-- <span>{{ $t('agree_terms_marketing')}}</span> -->
                <span v-html="translations.text.agree_terms_marketing"></span>
              </label>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <p
              class="control privacy_data_text"
              v-html="translations.text.data_policy_text"
            >
            </p>
          </div>
        </div>
      </div>

      <br>

      <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-success is-pulled-right is-medium next"
        :class="[isDisabled? 'disabledButton':'']"
        @click="validateCaptcha"
        :disabled="isDisabled"
      >
        <span class="icon is-small">
          <i class="fa fa-check"></i>
        </span>
        <span>{{$t("complete")}}</span>
      </a>
    </div>
    <!-- <div
        v-if="showEUNoticeModal"
        class="modal small EUModal"
        :class="{ 'is-active': showEUNoticeModal }"
      >
        <div class="modal-background"></div>
        <div class="modal-card">
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <h2>{{ $t('important_information') }}</h2>
                <div class="control">
                  <p
                  >{{ $t('important_information_text') }}</p>
                </div>
              </div>
            </div>
            <a
              class="button"
              href="https://my.eurotrader.eu/en/register/live"
            >{{ $t('continue').tTitle() }}</a>
          </section>
        </div>
      </div> -->
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../../config'
import moment from 'moment'
import { service } from '../../app'

export default {
  props: ['translations', 'step', 'legalType', 'isLead', 'upgrade'],
  data() {
    return {
      isDisabled: false,
      groups: {},
      version: 'live',
      countries: config.countries,
      nationalities: config.nationalities,
      titles: config.titles,
      monthDayIndexes: Array.from({ length: 31 }, (v, i) => ++i),
      years: [],
      numberOfShareholders: 1,
      numberOfDirectors: 1,
      grantNoDepositBonus: false,
      hiddenCountries: ['SY', 'IQ', 'AF', 'ER', 'LY', 'SS', 'KP', 'US', 'SD', 'RU', 'CA', 'SO', 'IR', 'TR', 'BE', 'JP', 'MM', 'YE', 'JM', 'HT', 'CD', 'BF', 'BB', 'AL', 'KY', 'ML', 'MZ', 'NG', 'PA', 'PH', 'SN', 'TZ', 'UG', 'CN','GB'],
      body: {
        title: '',
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        dialCode: '',
        nationality: '',
        phone: '',
        gender: '',
        address: '',
        address2: '',
        post_code: '',
        city: '',
        state_province: '',
        year_moved_to_address: '',
        website: '',
        skype_id: '',
        dateofbirth: '',
        dob: {
          day: null,
          month: null,
          year: null,
        },
        password: '',
        confirm_password: '',
        total_estimated_net_worth: '',
        total_estimated_annual_income: '',
        employment_status: '',
        source_of_income: '',
        forex_cfds_and_other_instruments: '',
        lose_capital_risk: '',
        prev_pro_qualifications: '',
        platform: '',
        account_type: '',
        tradingAccountCurrency: '',
        include_account_in_bonus_program: false,
        bonus_tos_with_link: false,
        tos_with_link: false,
        agree_terms_marketing: false,
        i_am_over_18: false,
        company_name: '',
        shareholders: [this.emptyShareholderDirector()],
        directors: [this.emptyShareholderDirector()],
        walletCurrency: 'USD',
        recaptchaToken: null
      },
      showEUNoticeModal: false,
      recaptcha: null
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
    }),
    filteredCountries() {
      for (var i = 0, keys = Object.keys(this.countries), ii = keys.length; i < ii; i++) {
        if (this.hiddenCountries.includes(keys[i])) {
          delete this.countries[keys[i]]
        }
      }
      return this.countries
    },
  },
  watch: {
    numberOfShareholders(s) {
      let cs = this.body.shareholders.length
      let sum = cs - s
      if (sum === 0) {
      } else if (sum < 0) {
        for (let i = sum; i < 0; i++) {
          this.body.shareholders.push(this.emptyShareholderDirector())
        }
      } else {
        this.body.shareholders.splice(-sum, sum)
      }
    },
    numberOfDirectors(s) {
      let cs = this.body.directors.length
      let sum = cs - s
      if (sum === 0) {
      } else if (sum < 0) {
        for (let i = sum; i < 0; i++) {
          this.body.directors.push(this.emptyShareholderDirector())
        }
      } else {
        this.body.directors.splice(-sum, sum)
      }
    },
    'body.country'(c) {
      this.body.dialCode = '+' + this.countries[c].dialCode
    },
    'body.firstname'(fn) {
      if (this.body.firstname === 'regtest_123go') {
        this.autofillTestData('individual')
      }
    },
    'body.company_name'(cn) {
      if (this.body.company_name === 'regtest_123go') {
        this.autofillTestData('company')
      }
    },
    'body.platform'() {
      this.body.account_type = ''
      this.getPlatformAccountGroups(this.body.platform, this.body.tradingAccountCurrency, this.version)
    },
    'body.tradingAccountCurrency'() {
      this.getPlatformAccountGroups(this.body.platform, this.body.tradingAccountCurrency, this.version).then(data => {
        let found = false
        for (let g in this.groups) {
          if (this.groups[g].name == this.body.account_type) {
            found = true
          }
        }

        if (!found) {
          this.body.account_type = ''
        }
      })
    },
    'body.account_type'() {
      if (this.$refs['group-' + this.body.account_type]) {
        this.body.tradingAccountCurrency = this.$refs['group-' + this.body.account_type][0].dataset.currency
      }

      if (this.body.account_type == 'pamm-investor' || this.body.account_type == 'vip') {
        this.body.include_account_in_bonus_program = false
        this.body.bonus_tos_with_link = false
      }
    },
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', 'Open Live Account | Eurotrader', this.$t('live_account'))
    let currentYear = moment().year()
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i)
    this.$bus.$on('isLead', this.handleLeadData)

    this.$bus.$on('grantNoDepositBonus', e => {
      this.grantNoDepositBonus = e
    })

    if (this.Language == 'zh') {
      this.titles = {
        mrs: '太太',
        mr: '先生',
        ms: '女士',
        miss: '小姐',
        dr: '博士',
        other: '其它',
      }
    }
    this.$validator.extend('is-underage', {
      getMessage: field => {
        return 'You must be 18 or older to open an account'
      },
      validate: (value, obj) => {
        let age = obj.age
        let type = obj.type
        if (type == 'individual') {
          return this.age > age
        } else if (type == 'shareholder') {
          let approved = true
          this.shareholderAges.some(sAge => {
            if (sAge < age) {
              approved = false
              return !approved
            }
          })
          return approved
        } else if (type == 'director') {
          let approved = true
          this.directorAges.some(dAge => {
            if (dAge < age) {
              approved = false
              return !approved
            }
          })
          return approved
        }
      },
    })
  },
  created() {},
  beforeDestroy() {
    this.$bus.$off('isLead', this.handleLeadData)
  },
  methods: {
    validateCaptcha() {
      this.$recaptchaLoaded()
      this.recaptcha = this.$recaptcha('complete')

      var badge = document.getElementsByClassName('grecaptcha-badge')[0]
      badge.style.zIndex = '21'

      this.recaptcha.then(value => {
        this.complete(value)
      }).catch(err => {
        console.log(err)
      })
    },
    handleLeadData(e) {
      if (!e) {
        return
      }
      let required = ['title', 'firstname', 'lastname', 'email', 'country', 'phone']
      for (let v of required) {
        if (typeof this.$route.query[v] !== 'undefined' && typeof this.body[v] !== 'undefined') {
          this.body[v] = this.$route.query[v]
        }
      }
    },
    emptyShareholderDirector() {
      return {
        firstname: '',
        lastname: '',
        dateofbirth: '',
        dob: {
          day: -1,
          month: -1,
          year: -1,
        },
        country: '',
        address: '',
        address2: '',
        post_code: '',
        city: '',
        state_province: '',
        year_moved_to_address: -1,
      }
    },
    composeSpecialFields() {
      this.body.dateofbirth = this.body.dob.year + '-' + this.body.dob.month + '-' + this.body.dob.day
      this.body.year_moved_to_address = parseInt(this.body.year_moved_to_address)
      if (isNaN(this.body.year_moved_to_address)) {
        this.body.year_moved_to_address = ''
      }
      if (this.legalType === 'company') {
        for (let i = 0, l = this.body.shareholders.length; i < l; i++) {
          this.body.shareholders[i].dateofbirth = this.body.shareholders[i].dob.year + '-' + this.body.shareholders[i].dob.month + '-' + this.body.shareholders[i].dob.day
          this.body.shareholders[i].year_moved_to_address = parseInt(this.body.shareholders[i].year_moved_to_address)
        }
        for (let i = 0, l = this.body.directors.length; i < l; i++) {
          this.body.directors[i].dateofbirth = this.body.directors[i].dob.year + '-' + this.body.directors[i].dob.month + '-' + this.body.directors[i].dob.day
          this.body.directors[i].year_moved_to_address = parseInt(this.body.directors[i].year_moved_to_address)
        }
      }
    },
    getPlatformAccountGroups(platform, currency, mode) {
      return new Promise((resolve, reject) => {
        resolve(
          service
            .post('/account-types/list-filtered', {
              platform: platform,
              currency: currency,
              mode: mode,
            })
            .then(response => {
              if (response.data) {
                this.groups = Object.assign({}, this.$moveInvestorLast(response.data.account_types))
              }
            })
            .catch(error => {
              console.log(error.response.data)
            })
        )
      })
    },
    nextStep() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.composeSpecialFields()
          this.$bus.$emit('NextStep', this.body)
          return
        }
        // scroll to first message
        let el = document.getElementsByName(this.errors.items[0].field)[0]
        el.focus()
      })
    },
    complete(token) {
      this.body.recaptchaToken = token

      if (this.grantNoDepositBonus === true) {
        this.body.account_type = 'no-deposit-bonus'
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.body.tos_with_link || (this.body.include_account_in_bonus_program && !this.body.bonus_tos_with_link)) {
            this.$toasted.error(this.$t('must_agree_terms'))
            return
          }

          if (this.legalType == 'individual' && new Date().getFullYear() - this.body.dob.year < 18) {
            this.$toasted.error(this.$t('must_be_over_18'))
            return
          }

          if (this.legalType == 'company') {
            for (let i = 0, l = this.body.shareholders.length; i < l; i++) {
              if (new Date().getFullYear() - this.body.shareholders[i].dob.year < 18) {
                this.$toasted.error(this.$t('shareholders_must_be_over_18'))
                return
              }
            }
            for (let i = 0, l = this.body.directors.length; i < l; i++) {
              if (new Date().getFullYear() - this.body.directors[i].dob.year < 18) {
                this.$toasted.error(this.$t('directors_must_be_over_18'))
                return
              }
            }
          }

          this.composeSpecialFields()
          this.isDisabled = true
          this.$bus.$emit('Complete', this.body)
        }
      })
    },
    autofillTestData(type) {
      if (type === 'individual') {
        this.body.title = 'mr'
        this.body.firstname = 'test'
        this.body.lastname = 'test'
      } else if (type === 'company') {
        this.body.company_name = 'testcompany'

        this.body.shareholders[0].firstname = 'test'
        this.body.shareholders[0].lastname = 'test'
        this.body.shareholders[0].dob.year = 1986
        this.body.shareholders[0].dob.month = 3
        this.body.shareholders[0].dob.day = 21
        this.body.shareholders[0].address = 'test'
        this.body.shareholders[0].address2 = 'test'
        this.body.shareholders[0].post_code = Math.floor(Math.random() * 89999 + 10000).toString()
        this.body.shareholders[0].city = 'test'
        this.body.shareholders[0].state_province = 'test'
        this.body.shareholders[0].country = 'GB'
        this.body.shareholders[0].year_moved_to_address = 1999

        this.body.directors[0].firstname = 'test'
        this.body.directors[0].lastname = 'test'
        this.body.directors[0].dob.year = 1986
        this.body.directors[0].dob.month = 3
        this.body.directors[0].dob.day = 21
        this.body.directors[0].address = 'test'
        this.body.directors[0].address2 = 'test'
        this.body.directors[0].post_code = Math.floor(Math.random() * 89999 + 10000).toString()
        this.body.directors[0].city = 'test'
        this.body.directors[0].state_province = 'test'
        this.body.directors[0].country = 'GB'
        this.body.directors[0].year_moved_to_address = 1999
      }
      this.body.email = 'test' + moment() + '@test.com'
      // this.body.country = 'GB'
      this.body.phone = '8' + moment()

      this.body.dob.day = 11
      this.body.dob.month = 7
      this.body.dob.year = 1985
      // this.body.nationality = 'British'
      this.body.gender = 'male'
      this.body.address = 'test'
      this.body.address2 = 'test'
      this.body.post_code = Math.floor(Math.random() * 89999 + 10000).toString()
      this.body.city = 'test'
      this.body.state_province = 'test'
      this.body.year_moved_to_address = 1999 // TESTING errors

      this.body.total_estimated_net_worth = '<5000'
      this.body.total_estimated_annual_income = '<15000'
      this.body.employment_status = 'employed'
      this.body.source_of_income = 'employment'
      this.body.forex_cfds_and_other_instruments = 'yes'
      this.body.lose_capital_risk = 'yes'
      this.body.prev_pro_qualifications = 'yes'
      this.body.platform = 'mt4'
      this.body.account_type = 'gold'
      this.body.tradingAccountCurrency = 'usd'
      this.body.include_account_in_bonus_program = false
      this.body.bonus_tos_with_link = true
      this.body.tos_with_link = true
      this.body.agree_terms_marketing = false
    },
    // checkIfIsEuropeanCountry() {
    //   if (config.EUCountries.includes(this.body.country)) {
    //     this.showEUNoticeModal = true
    //     return
    //   }
    //   this.showEUNoticeModal = false
    // }
  },
}
</script>

<style lang="scss">
@import '../../assets/css/variables';

.live .step {
  margin-left: 4%;
}
.live .progressNum {
  margin-bottom: 78px;
}

.live .progressNum > ul {
  display: table;
  margin: 0 auto;
}
.live .progressNum > ul li {
  width: auto;
  font: normal normal 900 47px/53px Roboto;
  letter-spacing: -0.94px;
  color: #fff;
  @media screen and (max-width: $mobile) {
    font-size: 20px;
  }
  span {
    font-size: 16px;
    line-height: 34px;
    letter-spacing: -0.32px;
    color: #b591fb;
    margin-top: 10px;
    display: table;
    text-transform: capitalize;
  }
  &::before {
    width: 78px;
    height: 78px;
    border: 0;
    line-height: 78px;
    background-color: #b591fb;
    @media screen and (max-width: $mobile) {
      width: 40px;
      height: 40px;
      line-height: 40px;
    }
  }
}

.live .progressNum > ul li.active {
  color: #fff;
  font-weight: 900;
  span {
    color: #6826f4;
  }
  &::before {
    background-color: #6826f4;
  }
}

.live span.step_divider {
  height: 2px;
  width: 192px;
  background-color: #b591fb;
  float: left;
  margin-top: 5%;
  margin-left: 25px;
  margin-right: 25px;
  @media screen and (max-width: $mobile) {
    width: 50px;
    margin-top: 7%;
    margin-left: 15px;
    margin-right: 15px;
  }
}

.live .step > h2 {
  font: normal normal 900 30px/34px Roboto;
  letter-spacing: -0.6px;
  text-transform: capitalize;
  border: 0;
}

.live .previous {
  width: 152px;
  height: 40px;
  background-color: #7b7c7e;
  border-radius: 23px;
  font: normal normal 500 12px/14px Roboto;
  letter-spacing: 0px;
  margin-top: 54px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: $mobile) {
    margin-bottom: 55px;
  }
}

.live .next {
  width: 152px;
  height: 40px;
  background-color: #6826f4;
  border-radius: 23px;
  font: normal normal 500 12px/14px Roboto;
  letter-spacing: 0px;
  margin-top: 54px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: $mobile) {
    margin-bottom: 55px;
  }
}

@media screen and (max-width: $mobile) {
  .live .columns {
    margin: 0;
  }
}

.step input.push-left {
  padding-left: 63px;
}

.dialcodeBox {
  position: absolute;
  left: 11px;
  top: 9px;
  z-index: 1;
  color: #10182a;
  font: normal normal 300 18px/28px Roboto;
}

.modal.EUModal {
    h2{
      font: normal normal 900 30px/34px Roboto;
      color: #10182a;
      margin-bottom: 30px;
      text-align: left;
      border:0;
      @media only screen and (max-width: 768px) {
          font-size: 25px;
      }
    }
    .modal-card{
      padding: 40px;
      background: #fff;
      border-bottom-right-radius: 30px;
      @media only screen and (max-width: 768px) {
          padding: 0;
      }
      .modal-card-body{
        @media only screen and (max-width: 768px) {
          padding-top: 30px;
          padding-bottom: 40px;
        }
      }
      p{
        text-align: left;
        font: normal normal 300 16px/24px Roboto;
        letter-spacing: 0px;
        color: #10182a;
      }
    }
    .button{
        width: 220px;
        height: 47px;
        background-color: #6826f4;
        border-radius: 23px;
        font: normal normal 400 14px/14px Roboto;
        letter-spacing: 0px;
        margin-top: 20px;
        color: #fff;
        transition: all 0.3s ease-in-out;
    }
}
</style>



// WEBPACK FOOTER //
// Live.vue?b036f41c